<template>
  <v-card>
    <v-container py-0 fluid>
      <v-row>
        <v-col 
          v-for="cat in cats" 
          :key="cat"
        >
          <app-filter
            :items="selects[cat]"
            :filter="filters[cat]"
            :cat="cat"
            :criteriaFilter="criteriaFilters[cat]"
            @filterUpdate="filterUpdate"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import axios from 'axios'
  import { ucFirst } from './../formatters.js'
  import Filter from './Filter.vue'
  export default {
    components: {
      AppFilter : Filter
    },
    props : ['cats', 'filters', 'criteriaFilters'],
    data(){
      return {
        //cats : ['bidder','custadunit','device','invtype','inventory'],
        loading: false,
        selects : {}
      }
    },
    created(){
      this.getDataFromApi()
      this.$emit('filtersUpdate',this.filters)
    },
    watch:{
    },
    methods: {
      async getDataFromApi() {
        this.loading = true
        const request = {
          type :"reporting/reporting",
          action : "getSelects",
        };
        try {
          const accessToken = await this.$auth.getAccessToken()
          const response = await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          const output = {};
          Object.keys(response.data).forEach(function(key){
            const foo = response.data[key].map(function(item){
              return {
                text: ucFirst(item.text),
                value : item.value
              }
            })
            output[key] =foo
          })
          this.selects = output		     
          this.loading = false
        } catch (e) {
          console.error(e)
          this.loading = false  
        }
      },
      filterUpdate(data){
        this.filters[data.cat] = data.filter
        this.$emit('filtersUpdate',this.filters)
      },
    },
    computed:{
      labels(){
        let output = {}
        this.cats.forEach((cat) =>{
          output[cat] = cat.charAt(0).toUpperCase() + cat.slice(1)
        })
        return output
      }
    },
    
  } 
</script>